<template>
  <div class="physical-assessment-check">
    <md-chip class="md-primary"> Was physical assessment performed at</md-chip>
    <state-input
      :state="locations"
      :initial-value="state.check.ids"
      :synced-value="state.check.ids"
      :show-label="false"
      :multiple="true"
      width="220px"
      :disabled="readonly"
      placeholder="any location"
      class="location-input"
      @input="value => updateLocations(value)"
    />
  </div>
</template>

<script>
import StateInput from '~lib/common/components/StateInput.vue';

export default {
  name: 'physical-assessment-check',
  components: {
    StateInput,
  },
  props: [
    'states',
    'readonly',
    'emitter',
    'ikey',
    'getData',
    'putData',
    'control',
  ],
  data() {
    return {
      state: {
        check: {
          ids: [],
        },
      },
    };
  },
  computed: {
    locations() {
      const state = this.states.find(s => s.id === 'physicalAssessmentLocations');
      return state ? {
        ...state,
        possibleValues: state.possibleValues.filter(value => value.key !== 'FULL_BODY')
      } : [];
    }
  },
  mounted() {
    this.state.check = {
      ...this.state.check,
      ...(this.getData(this.ikey) || {}),
    };
    this.update();
  },
  methods: {
    updateLocations(locationIds) {
      this.state.check.ids = locationIds;
      this.update();
    },
    update() {
      this.putData(this.ikey, {
        ...this.state.check,
        type: 'PHYSICAL_ASSESSMENT_ASSESSED',
        operator: 'EQUAL',
        value: true,
      });
      this.emitter.trigger('process', this.control);
      this.$forceUpdate();
    },
  },
};
</script>

<style scoped>
.physical-assessment-check {
  display: flex;
  flex-direction: row;
}
</style>
